<template>
  <v-container fluid class="gl-journal-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Journal</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="12">
                      <p class="text-h5">New General Journal</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <v-select
                          class="mb-4"
                          :items=journaltype
                          v-model="new_journal.journaltype"
                          v-bind:error="errorindex == 0"
                          v-on:change="clearFields(); clearTransactions()"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the journal type">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="new_journal.journalname"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Journal Name"
                          persistent-hint
                          single-line hint="Enter journal name">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <v-menu
                          ref="menu_journaldate"
                          v-model="menu_journaldate"
                          :close-on-content-click="false"
                          :return-value.sync="new_journal.journaldate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              v-model="new_journal.journaldate"
                              label="Journal Date"
                              v-bind="attrs"
                              v-bind:value="new_journal.journaldate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the journal date"
                              persistent-hint
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_journal.journaldate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_journaldate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_journaldate.save(new_journal.journaldate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-select
                        dense
                        outlined
                        class="mb-4"
                        :items="glledgers.map(x => {
                          return {text: x.ledgername, value: x._id};
                        })"
                        v-model="new_journal.ledgerid"
                        v-bind:error="errorindex == 3"
                        placeholder="Ledger"
                        persistent-hint
                        single-line hint="Ledger"
                      >
                      </v-select>
                      </v-form>
                    </v-col>   
                    <v-col cols="12" md="3">
                      <v-row>
                          <v-col cols="12" md="6">
                            <v-select
                              class="mb-2"
                              :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                              v-model="new_journal.primaryCurrency"
                              v-bind:error="error == 'primaryCurrency'"
                              outlined
                              dense
                              placeholder="Currency 1"
                              persistent-hint
                              single-line hint="Primary Currency">
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-select
                              class="mb-2"
                              :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                              v-model="new_journal.secondaryCurrency"
                              v-bind:error="error == 'secondaryCurrency'"
                              v-bind:value="primaryCurrency"
                              outlined
                              dense
                              placeholder="Currency 2"
                              persistent-hint
                              single-line hint="Second Currency">
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-text-field
                          class="mb-4"
                          v-model="new_journal.currencyRate"
                          v-bind:error="error == 'currencyRate'"
                          :v-bind:value="1"
                          outlined
                          dense
                          placeholder="Rate"
                          persistent-hint
                          single-line hint="Rate">
                        </v-text-field>
                    </v-col>                              
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/gl-journal/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkGLJournal">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row>
                    <v-col md="10">
                      <p class="text-h5">Items</p>
                    </v-col>
                    <v-col md="2" align="right">
                      <v-btn
                        class="button-shadow"
                        color="success"
                        @click="isAddTransaction=true">
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-data-table
                          :headers="header_transaction"
                          :items="transactions"
                          :items-per-page="500"
                          :footer-props="footer"
                          class="elevation-0"
                        >
                        <template v-slot:body.append>
                            <tr>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>{{sum_credit}}</td>
                              <td>{{sum_debit}}</td>
                              <td><div v-html="balance_text"></div></td>
                            </tr>
                          </template>
                          <template v-slot:item.accountid="{ item }">
                            <div v-if="item.accountid!=null">{{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}</div>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn icon color="primary" @click="editTransactionDialog(item)">
                              <v-icon>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn icon color="primary" @click="deleteTransaction(item)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                          outlined
                          color="primary"
                          @click="step = 1"
                        >
                          Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="insertGLJournal()">
                          Save
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_classes
                    v-model="accountclass"
                    outlined
                    dense
                    placeholder="Class"
                    persistent-hint
                    single-line hint="Please choose the class">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses
                    v-model="accountsubclass"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass).map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="new_transaction.accountid"
                    v-bind:error="errorindex == 11"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="new_transaction.transdesc"
                    v-bind:error="errorindex == 12"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.creditAmount"
                    v-bind:error="errorindex == 13"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Credit"
                    persistent-hint
                    single-line hint="Credit Amount">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.debitAmount"
                    v-bind:error="errorindex == 14"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Debit"
                    persistent-hint
                    single-line hint="Debit Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="1000px"
        max-width="1000px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_classes
                    v-model="accountclass2"
                    outlined
                    dense
                    placeholder="Class"
                    persistent-hint
                    single-line hint="Please choose the class">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses2
                    v-model="accountsubclass2"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass2).map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="edit_transaction.accountid"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_transaction.transdesc"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.creditAmount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Credit"
                    persistent-hint
                    single-line hint="Credit Amount">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.debitAmount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Debit"
                    persistent-hint
                    single-line hint="Debit Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';
import { formatCurrency } from "../../../util/tools";

export default {
  data () {
    return {
      header_transaction: [
        { text: 'Account', value: 'accountid', width: '30%'},
        { text: 'Description', value: 'transdesc'},
        { text: 'Credit', value: 'creditAmount', width: '10%'},
        { text: 'Debit', value: 'debitAmount', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      classes: ['Cost of Good Sold', 'Administrative Expense', 'Operating Expense', 'Marketing Expense', 'Tax & Financing Expense', 'Factory & Production Expense', 'Debt & Loan', 'Overhead'],
      
      accountclass: null,
      accountclass2: null,
      accountsubclass: null,
      accountsubclass2: null,

      step: 1,
      new_journal: {},
      new_transaction: {},
      edit_transaction: {},
      transactions: [],

      isAddTransaction: false,
      isEditTransaction: false,
      menu_journaldate: false,
      menu_transdate: false,
      menu_transdate_edit: false,
      journaltype: ['General Journal'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      formatCurrency: formatCurrency,
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('GLJournal', ['gljournals', 'isReceiving']),
    ...mapState('GLLedger', ['glledgers']),
    ...mapState('Department', ['departments']),
    ...mapState('Location', ['locations']),
    ...mapState('SalesChannel', ['saleschannels']),
    data_classes(){
      let object = Object.groupBy(this.accounts, item => {
        return item.accountclass;
      });
      let result = Object.keys(object);
      return result;
    },
    data_subclasses(){
      let filter = this.accounts.filter(account=>account.accountclass==this.accountclass);
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return result;
    },
    data_subclasses2(){
      let filter = this.accounts.filter(account=>account.accountclass==this.accountclass2);
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return result;
    },
    sum_credit(){
      let result = this.transactions.reduce((a, b) => a + parseFloat(b.creditAmount), 0);
      console.log('2', result)
      return isNaN(result) ? 0 : this.formatCurrency(result);
    },
    sum_debit(){
      let result = this.transactions.reduce((a, b) => a + parseFloat(b.debitAmount), 0);
      console.log('1', result)
      return isNaN(result) ? 0 : this.formatCurrency(result);
    },
    balance_text(){
      let result;
      if(this.sum_debit !== this.sum_credit) result = '<p style="color: red; margin-top: 15px; font-weight: bold; font-size: 9pt;">Not In Balance</p>';
      else result = '<p>&nbsp;</p>';
      return result;
    },
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('GLJournal', ['getGLJournalsRequest', 'insertGLJournalRequest']),
    ...mapActions('GLLedger', ['getGLLedgersRequest']),
    ...mapActions('Department', ['getDepartmentsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('SalesChannel', ['getSalesChannelsRequest']),
    checkGLJournal(){
      if(!this.new_journal.journaltype){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_journal.journaldate){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_journal.journalname){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.new_journal.ledgerid){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkTransaction(){
      if(!this.new_transaction.accountid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.new_transaction.transdesc){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(this.new_transaction.creditAmount==null && this.new_transaction.debitAmount==null){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      if(this.new_transaction.creditAmount==null || this.new_transaction.creditAmount==''){
        this.new_transaction.creditAmount = 0;
      }
      if(this.new_transaction.debitAmount==null || this.new_transaction.debitAmount==''){
        this.new_transaction.debitAmount = 0;
      }
      this.errorindex = -1;
      return true;
    },
    addTransaction(){
      if(!this.checkTransaction()) return;
      let credit = this.new_transaction.creditAmount!=null ? this.new_transaction.creditAmount : 0;
      let debit = this.new_transaction.debitAmount!=null ? this.new_transaction.debitAmount : 0;
      let trans = Object.assign({}, this.new_transaction, {id: Math.floor(Math.random() * Math.pow(10, 10)), creditAmount: credit, debitAmount: debit});
      this.transactions.push(trans);
      this.clearFields();
      this.isAddTransaction = false;
    },

    clearFields(){
      this.new_transaction = {};
    },
    clearTransactions(){
      this.transactions = [];
    },
    async insertGLJournal() {
      if(this.transactions==null || this.transactions.length==0) return;
      if(this.sum_credit!==this.sum_debit) return;
      let payload = {journal: this.new_journal, transactions: this.transactions};
      await this.insertGLJournalRequest(payload);
      router.push('/gl-journal/list');
    },
    deleteTransaction(item){
      let index = this.transactions.findIndex((trans) => trans.id == item.id);      
      if(index!=-1) this.transactions.splice(index,1);
    },
    insertTransaction(){
      let trans = Object.assign({}, this.transactions_expense, {id: Math.floor(Math.random() * Math.pow(10, 10)),});
      this.transactions.push(trans);
    },
    editTransactionDialog(item){
      let account = this.accounts.find(account=>account._id == item.accountid);
      this.accountclass2 = account.accountclass;
      this.accountsubclass2 = account.accountsubclass;
      this.edit_transaction = Object.assign({}, item);
      this.isEditTransaction = true;
    },
    editTransaction(){
      if(this.edit_transaction.creditAmount==null || this.edit_transaction.creditAmount==''){
        this.edit_transaction.creditAmount = 0;
      }
      if(this.edit_transaction.debitAmount==null || this.edit_transaction.debitAmount==''){
        this.edit_transaction.debitAmount = 0;
      }
      let index = this.transactions.findIndex((trans) => trans.id == this.edit_transaction.id);
      let trans = Object.assign({}, this.edit_transaction);
      this.transactions.splice(index, 1, trans);
      this.isEditTransaction = false;
      this.edit_transaction = {};
    },
  },

  async created () {
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.glledgers.length==0) await this.getGLLedgersRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();

    //let currency = await this.getSetting({code: 'CurrencySettings', name: 'PrimaryCurrency'}, );
    //let isTaxable = await this.getSetting({code: 'TaxSettings', name: 'isTaxEnabled'}, );
    //this.new_journal = Object.assign({}, {primaryCurrency: currency, secondaryCurrency: currency, currencyRate: 1, isTaxable: isTaxable});
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
